




















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { MigrationImport } from "@/entities";
import DateComponent from "@/components/common/Inputs/Date.vue";
import FormattedNumber from "@/components/common/Inputs/FormattedNumber.vue";
import TableComponent from "./Components/TransactionTable.vue";

const namespace: string = "migration";
@Component({
  components: {
    TableComponent,
    DateComponent,
    FormattedNumber,
  },
})
export default class TransactionListComponent extends Vue {
  @State(namespace) migration!: MigrationImport;

  @Prop() schema: any;
  @Prop() model: any;
  @Prop() validations: any;
  @Prop() formOptions: any;

  grantInfo: any = {};

  get header() {
    if (this.schema && this.schema.transactionHeaders) {
      return this.schema.transactionHeaders.items;
    }
  }

  get dataModel() {
    if (!this.model.transactions) {
      this.model.transactions = [];
    }
    return this.model.transactions;
  }

  get budget() {
    let obj: any = {};
    if (
      this.migration.ImportData &&
      this.migration.ImportData.applicationBudget
    ) {
      obj = this.migration.ImportData.applicationBudget;
    }
    return obj;
  }

  get categories() {
    if (this.budget && this.budget.category) {
      return this.budget.category.filter((e) => e.id != 1);
    } else if (this.budget && this.budget.categories) {
      return this.budget.categories.filter((e) => e.id != 1);
    }
  }
}
